/**
 * @author: lv.chen
 * @date: 2026/7/16
 * @desc:
 */
import React from 'react';
import classnames from 'classnames';
import { Radio, RadioGroupProps } from 'tea-component';
import { REPORT_FILE_LANGUAGE_OPTIONS } from '@user-center/pages/ContentManagementCenter/Reports/MarketReports/constants';
import { LANG_TAB_I18N_MAP } from '@intelligence/utils/reportLanguage';
import useIntlExtend from '@intelligence/hooks/useIntlExtend';

import './index.scss';

// @ts-ignore
interface IReportRadioProps extends IBaseProps, RadioGroupProps {}

const ReportRadio: React.FC<IReportRadioProps> = (props) => {
  const { style, className, value, onChange } = props;

  const { formatMessage } = useIntlExtend();

  return (
    <div style={style} className={classnames('dbu-report-radio', className)}>
      <Radio.Group value={value} onChange={onChange}>
        {REPORT_FILE_LANGUAGE_OPTIONS.map((language) => {
          return (
            <Radio key={language} name={language}>
              {formatMessage({ id: LANG_TAB_I18N_MAP[language] })}
            </Radio>
          );
        })}
      </Radio.Group>
    </div>
  );
};

export default ReportRadio;
